import { render } from "./CardWrapper.vue?vue&type=template&id=6c6716c4"
import script from "./CardWrapper.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./CardWrapper.vue?vue&type=script&charset=utf-8&lang=js"

import "./CardWrapper.vue?vue&type=style&index=0&id=6c6716c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__